var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.972656 2.76027C0.972656 1.28375 2.16961 0.086792 3.64613 0.086792H14.3543C15.8309 0.086792 17.0278 1.28375 17.0278 2.76027V15.4133C17.0278 16.8898 15.8309 18.0867 14.3543 18.0867H3.64613C2.16961 18.0867 0.972656 16.8898 0.972656 15.4133V2.76027ZM3.64613 2.22557C3.35083 2.22557 3.11144 2.46496 3.11144 2.76027V15.4133C3.11144 15.7086 3.35083 15.948 3.64613 15.948H14.3543C14.6496 15.948 14.889 15.7086 14.889 15.4133V2.76027C14.889 2.46496 14.6496 2.22557 14.3543 2.22557H3.64613Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6236 14.793L4.6236 11.7758C4.6236 11.1852 5.10238 10.7064 5.69299 10.7064C6.28359 10.7064 6.76238 11.1852 6.76238 11.7758L6.76238 14.793L4.6236 14.793Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93207 14.793L7.93207 9.42567C7.93207 8.83506 8.41085 8.35628 9.00146 8.35628C9.59207 8.35628 10.0708 8.83506 10.0708 9.42567L10.0708 14.793L7.93207 14.793Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2405 14.793L11.2405 6.94929C11.2405 6.35869 11.7193 5.8799 12.3099 5.8799C12.9005 5.8799 13.3793 6.35869 13.3793 6.94929L13.3793 14.793L11.2405 14.793Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.4f903804.svg";
export { ForwardRef as ReactComponent };